<!--  -->
<template>
  <div>
    <div class="tencent-video-time">
      <div class="dis-24">辅导开始时间：{{appDetail.menteeResultTimeStr}} （{{appDetail.menteeZone | zoneTitleMap}}）</div>
      <div class="dis-48">已进行的时间：{{Math.floor(usedTime/60)}}mins</div>
    </div>
    <div class="tencent-video-btn">
      <Button class="zlr-btn-primary"
              @click="isEndTime = true"
              v-if="isLinkVideo">结束时间</Button>
    </div>
    <!-- 确定要结束时间吗 -->
    <zlr-modal v-model="isEndTime">
      <div class="sure-video-end">
        <h1>确定要结束辅导吗</h1>
        <div class="sur-video-btn">
          <Button class="zlr-btn-default"
                  @click="isEndTime = false">取消</Button>
          <Button class="zlr-btn-primary"
                  @click="handleEnd">确定</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>
<script>
// api
import { getAppRemainTime } from '@/api/appointment'
// components
import ZlrModal from '_c/modal/modal'
export default {
  name: 'tencent-video-time',
  components: {
    ZlrModal
  },
  props: ['appDetail', 'isLinkVideo', 'usedTime'],
  data () {
    return {
      remainTime: {},
      isEndTime: false
    }
  },
  computed: {},
  mounted () {
    this.getAppRemainTime()
  },
  methods: {
    getAppRemainTime () {
      let appDetail = this.appDetail
      getAppRemainTime({
        'jointId': appDetail.jointId,
        'module': appDetail.module,
        'appointmentType': appDetail.type
      }).then(res => {
        this.remainTime = res.data.model
      })
    },
    // 确定断开连接
    handleEnd () {
      this.isEndTime = false
      this.$emit('on-close')
    }
  },
  watch: {
    appDetail () {
      this.getAppRemainTime()
    }
  }
}
</script>
<style lang='less' scoped>
.sure-video-end {
  h1 {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.8);
    text-align: center;
    margin-bottom: 40px;
  }
  .sur-video-btn {
    text-align: center;
    button {
      margin: 0 20px;
    }
  }
}
</style>
